import { DOCUMENT, NgClass, NgOptimizedImage } from '@angular/common';
import { AfterViewInit, Component, Inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UserGroupService } from '@core/services/user-group.service';
import { SidebarService } from '@layout/core/services';
import { TranslateModule } from '@ngx-translate/core';
import { AppRoutes } from '@shared/helpers';
import { ButtonModule } from 'primeng/button';
import { SidebarModule } from 'primeng/sidebar';
import { AppNavigationComponent } from '../app-navigation/app-navigation.component';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    // eslint-disable-next-line @angular-eslint/no-host-metadata-property
    host: {
        '(window:resize)': 'onScreenResize()',
    },
    standalone: true,
    imports: [
        SidebarModule,
        AppNavigationComponent,
        NgClass,
        ButtonModule,
        RouterModule,
        TranslateModule,
        NgOptimizedImage,
    ],
})
export class SidebarComponent implements AfterViewInit {
    readonly appRoutes = AppRoutes;

    isVisible = true;
    isCollapsed = true;
    hasScrollbar = false;
    isSidebarDisabled: boolean = false;

    constructor(
        private sidebarService: SidebarService,
        private userGroupService: UserGroupService,
        @Inject(DOCUMENT) private document: Document
    ) {
        this.onScreenResize();
        sidebarService.isCollapsed$.subscribe((isCollapsed: boolean) => {
            this.isCollapsed = isCollapsed;
        });

        this.userGroupService.groups$.subscribe(groups => {
            this.isSidebarDisabled = !groups?.length;
        });
    }

    ngAfterViewInit(): void {
        this.onScreenResize();
    }

    toggleIsCollapsed(): void {
        this.sidebarService.toggleIsCollapsed();
    }

    onScreenResize() {
        const scrollHeight = this.document.getElementsByClassName('p-sidebar-content')[0]?.scrollHeight || 0;
        const clientHeight = this.document.getElementsByClassName('app-sidebar')[0]?.clientHeight || 0;
        this.hasScrollbar = scrollHeight + 70 > clientHeight;
    }
}
